import {
  BusinessResponse,
  MenuGroupListResponse,
  SlotCollectionResponse, SubGroupCollectionResponse
} from "@/types/service-response";
import _ from "lodash";

export default class MenuGroupList {
  private constructor(
      readonly business: BusinessResponse,
      readonly createdAt: string,
      readonly id: number,
      readonly isTopMenuGroup: boolean,
      readonly title: string,
      readonly order: number,
      readonly menuGroupSlots: SlotCollectionResponse[],
      readonly subMenuGroups: SubGroupCollectionResponse[],
      readonly tags: string[]

  ) {}


  static createFromResponse(responseData: MenuGroupListResponse): MenuGroupList {

    return new MenuGroupList(
        responseData.business,
        responseData.createdAt,
        responseData.id,
        responseData.isTopMenuGroup,
        responseData.title,
        responseData.order,
        _.orderBy(responseData.menuGroupSlots, 'order'),
        _.orderBy(responseData.subMenuGroups, 'order'),
        responseData.tags
    )
  }

  static createFromResponseList(responseData: MenuGroupListResponse[]): MenuGroupList[] {

    let subGroupIdList: number[] = []
    responseData.forEach((item: MenuGroupListResponse) => {
      subGroupIdList = subGroupIdList.concat(item.subMenuGroups.map((item: SubGroupCollectionResponse) => item.id))
    })

    let groupList: MenuGroupListResponse[] = responseData.filter((item: MenuGroupListResponse) => !subGroupIdList.includes(item.id))
    groupList = _.orderBy(groupList, 'order')

    let menuGroupIdList: number[] = groupList.map((i: MenuGroupListResponse) => {
      return i.id
    })


    return groupList.map((item:MenuGroupListResponse) => {
      return new MenuGroupList(
          item.business,
          item.createdAt,
          item.id,
          menuGroupIdList.includes(item.id),
          item.title,
          item.order,
          _.orderBy(item.menuGroupSlots, 'order'),
          _.orderBy(item.subMenuGroups, 'order'),
          item.tags
      )
    })
  }

  public updateOrder (order: number): MenuGroupList {
    return new MenuGroupList(
        this.business,
        this.createdAt,
        this.id,
        this.isTopMenuGroup,
        this.title,
        order,
        this.menuGroupSlots,
        this.subMenuGroups,
        this.tags
    )
  }
}